import ReportComponent from '../components/report/report'

const Report = () => <ReportComponent />

export default Report;